const TAG_TYPES = {
  PIPELINE: 'PIPELINE',
};

export default TAG_TYPES;
